import Folder from "../domain/Folder";
import {ExpandedFolderIdPref} from "../util/Preferences";
import {Dispatch} from "redux";
import {AppState} from "../AppState";
import {
    BeginCreateSubFolderAction,
    BeginMoveFolderAction,
    BeginRenameFolderAction,
    CancelMoveFolderAction,
    CREATE_SUB_FOLDER_BEGIN,
    EXPAND_FOLDER,
    FOLDERS_LOADED,
    FoldersLoadedAction,
    HIDE_EDIT_FOLDER_DIALOG,
    HideEditFolderDialogAction,
    MOVE_FOLDER_BEGIN,
    MOVE_FOLDER_CANCEL,
    PERFORM_SEARCH_ASYNC,
    PerformSearchAction,
    RENAME_FOLDER_BEGIN,
    SEARCH_RESULTS_LOADED,
    SearchResultsLoadedAction,
    SET_CONTEXT_FOLDER,
    SetContextFolderAction,
} from "./FolderActionTypes";
import {EmailDataSourceResult} from '../domain/EmailDataSource';
import {EmailActions} from './EmailActions';
import {ManageFolderRemoteOperationDto} from '../services/messages/operations/ManageFolderRemoteOperationDto';
import {PayloadAction} from "@reduxjs/toolkit";
import {AddRemoteOperationPayload} from "../redux/SyncSlice";
import {IDatasource} from "ag-grid-community/dist/types/src/interfaces/iDatasource";
import {AppDispatch} from "../AppStore";

export class FolderActions {
    static foldersLoaded(folders: Folder[]): FoldersLoadedAction {
        return { type: FOLDERS_LOADED, folders};
    }

    static expandFolder(dispatch: Dispatch, getState: () => AppState, folderId: number, expand: boolean) {
        dispatch({ type: EXPAND_FOLDER, folderId, expand });

        ExpandedFolderIdPref.set(getState().folderState.expandedFolderIds);
    }

    static setContextFolder(folder: Folder | undefined): SetContextFolderAction {
        return { type: SET_CONTEXT_FOLDER, folder };
    }

    static performSearchAsync(emailDataSource?: IDatasource, currentSearchText?: string, error?: Error): PerformSearchAction {
        return { type: PERFORM_SEARCH_ASYNC, emailDataSource, currentSearchText, error };
    }

    static searchResultsLoaded(results?: EmailDataSourceResult): SearchResultsLoadedAction {
        return { type: SEARCH_RESULTS_LOADED, results };
    }

    static beginRenameFolder(folder: Folder): BeginRenameFolderAction {
        return { type: RENAME_FOLDER_BEGIN, folder };
    }

    static beginCreateSubFolder(parentFolder: Folder): BeginCreateSubFolderAction {
        return { type: CREATE_SUB_FOLDER_BEGIN, parentFolder };
    }

    static beginMoveFolder(folder: Folder): BeginMoveFolderAction {
        return { type: MOVE_FOLDER_BEGIN, folder };
    }

    static cancelMoveFolder(): CancelMoveFolderAction {
        return { type: MOVE_FOLDER_CANCEL };
    }

    static hideEditFolderDialog(): HideEditFolderDialogAction {
        return { type: HIDE_EDIT_FOLDER_DIALOG };
    }

    static async deleteFolder(folder: Folder): Promise<PayloadAction<AddRemoteOperationPayload>> {
        const ManageFolder: ManageFolderRemoteOperationDto = { DeleteFolder: { ServerId: folder.serverId } };
        return EmailActions.addRemoteOperation({ ManageFolder });
    }

    static async completeMoveFolder(dispatch: AppDispatch, folder: Folder, newParentServerId: string): Promise<void> {
        const ManageFolder: ManageFolderRemoteOperationDto = { MoveFolder: { ServerId: folder.serverId, NewParentServerId: newParentServerId } };
        dispatch(await EmailActions.addRemoteOperation({ ManageFolder }));
    }

    static async completeEditFolder(folder: Folder, newName: string): Promise<PayloadAction<AddRemoteOperationPayload>> {
        const isNewFolder = folder.folderId === -1;

        if (isNewFolder) {
            const ManageFolder: ManageFolderRemoteOperationDto = {
                CreateSubFolder: {
                    ParentServerId: folder.parentId,
                    Name: newName,
                    ServerId: folder.serverId
                }
            };
            return EmailActions.addRemoteOperation({ManageFolder});
        } else {
            const ManageFolder: ManageFolderRemoteOperationDto = {RenameFolder: {ServerId: folder.serverId, Name: newName}};
            return EmailActions.addRemoteOperation({ManageFolder});
        }
    }
}
